import { Component, ViewChild } from '@angular/core';
import { AuthService, Key } from '@kpd/framework-ngx';
import { UserService } from 'app/shared/services/user.service';
import { User } from 'app/shared/models/user';
import { AuthenticationProviders } from '../../enums/authentication-providers';
import { ChangePasswordFormgroupComponent } from 'app/shared/components/change-password/change-password-formgroup.component';

@Component({
  selector: 'app-change-password',
  templateUrl: './change-password.component.html',
})
export class ChangePasswordComponent {
  user: User = new User();
  saved = false;
  loading = false;

  @ViewChild(ChangePasswordFormgroupComponent, { static: false })
  changePasswordFormGroupComponent: ChangePasswordFormgroupComponent;

  constructor(private authService: AuthService, private userService: UserService) {
    this.userService.getById(this.userKey).subscribe(user => {
      this.user = user;
    });
  }

  get userKey(): Key<string> {
    return new Key<string>(this.authService.getIdentity().upn);
  }

  get isLocalUser(): boolean {
    return this.user.allowedAuthenticationProviders === AuthenticationProviders.local;
  }

  onPasswordChanged(): void {
    this.saved = true;
  }

  onSubmit(): void {
    this.changePasswordFormGroupComponent.onSubmit();
  }
}
